import { render, staticRenderFns } from "./NavSeparator.vue?vue&type=template&id=a897408a&scoped=true&"
import script from "./NavSeparator.vue?vue&type=script&lang=js&"
export * from "./NavSeparator.vue?vue&type=script&lang=js&"
import style0 from "./NavSeparator.vue?vue&type=style&index=0&id=a897408a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a897408a",
  null
  
)

export default component.exports